import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.css';

const API_URL =
  process.env.NODE_ENV === 'development'
    ? ''
    : (process.env.REACT_APP_API_URL || '');

export default function Login() {
  const [cedula, setCedula] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje({ tipo: '', texto: '' });

    if (!cedula.trim()) {
      setMensaje({ tipo: 'error', texto: 'La cédula es obligatoria.' });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cedula: cedula.trim() }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem('usuario', JSON.stringify(data.usuario));
        window.dispatchEvent(new CustomEvent('user-login'));
        navigate('/');
      } else {
        setMensaje({ tipo: 'error', texto: data.error || 'Error al iniciar sesión.' });
      }
    } catch (err) {
      console.error('[Login] Error de conexión:', err);
      setMensaje({
        tipo: 'error',
        texto: 'No se pudo conectar con el servidor. Verifique que esté en ejecución.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.login}>
      {/* Hero: logo (como en página de inicio) */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoCircle}>
              <img
                src={`${process.env.PUBLIC_URL}/logo.gif`}
                alt="4to MasterClass EPI - Juntos Transformando Vidas"
                className={styles.logoImg}
              />
            </div>
          </div>
        </div>
      </section>

      <section className={styles.formSection}>
        <div className={styles.formCard}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label htmlFor="cedula">Cédula*</label>
              <input
                id="cedula"
                type="text"
                value={cedula}
                onChange={(e) => setCedula(e.target.value)}
                placeholder="Ingrese su número de cédula"
                required
              />
            </div>
            {mensaje.texto && (
              <p className={mensaje.tipo === 'exito' ? styles.mensajeExito : styles.mensajeError}>
                {mensaje.texto}
              </p>
            )}
            <button type="submit" className={styles.botonLogin} disabled={loading}>
              {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
            </button>
          </form>
        </div>
      </section>

      <section className={styles.info}>
        <div className={styles.infoContent}>
          <img
            src={`${process.env.PUBLIC_URL}/frase.gif`}
            alt="Más de una década de evidencia, más de un siglo de innovación"
            className={styles.fraseImg}
          />
        </div>
      </section>
    </div>
  );
}
